import classNames from 'classnames'
import {memo, useContext, useEffect, useState} from 'react'

import type {BuildId} from '../../../../../types'
import {FullLogTarget} from '../../BuildLog.types'
import BuildLogTimeline from '../../BuildLogTimeline/BuildLogTimeline.container'
import DownloadBuildLog from '../../DownloadBuildLog/DownloadBuildLog'
import {TargetContext} from '../FullBuildLog.context'

import BuildLogControls from './BuildLogControls/BuildLogControls'
import BuildLogSearch from './BuildLogSearch/BuildLogSearch'
import RelativeTimeButton from './RelativeTimeButton/RelativeTimeButton'
import SoftWrapLogLines from './SoftWrapLogLines/SoftWrapLogLines'

import styles from './BuildLogHeader.css'

type Props = {
  buildId: BuildId
}

function BuildLogHeader({buildId}: Props) {
  const target = useContext(TargetContext)
  const [searchActive, setSearchActive] = useState(false)

  useEffect(() => {
    setSearchActive(false)
  }, [buildId])

  return (
    <div
      className={classNames(styles.header, {
        [styles.targetPage]: target === FullLogTarget.PAGE,
      })}
    >
      <div className={styles.controls}>
        {searchActive ? (
          <BuildLogSearch setSearchActive={setSearchActive} />
        ) : (
          <BuildLogControls setSearchActive={setSearchActive} />
        )}
        <div className={styles.rightControls}>
          <DownloadBuildLog buildId={buildId} />
          <SoftWrapLogLines className={styles.settingsAction} />
          <RelativeTimeButton className={styles.settingsAction} />
        </div>
      </div>
      <BuildLogTimeline buildId={buildId} logTarget={target} />
    </div>
  )
}

export default memo(BuildLogHeader)
